<template>
	<div>
		<template v-if="appweb.moduleId == 'bTSXa6odYbFhgLHWr'">
			<HomeTemplate></HomeTemplate>
		</template>
		<template v-if="appweb.moduleId == '6w3XxZ5e9CJKnTtkX'">
			<HomeTemplate2></HomeTemplate2>
		</template>
		<template v-if="appweb.moduleId == 'bTSXa6odYbFhgLFWt'">
			<HomeTemplate3></HomeTemplate3>
		</template>
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
	name: "choicetemplate",
	data() {
		return {};
	},
	mounted() {},
	methods: {},
	computed: {
		...mapState(["appweb"])
	}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/choicetemplate.vue